// app.config.js

"use strict";
appConfig.$inject = ['$ocLazyLoadProvider', "$compileProvider", "$sceDelegateProvider"];

export default function appConfig($ocLazyLoadProvider, $compileProvider, $sceDelegateProvider)
{
  $compileProvider.debugInfoEnabled(process.env.NODE_ENV == 'development' ? false : true);
  $ocLazyLoadProvider.config({
    debug: process.env.NODE_ENV == 'development' ? true : false,
    events: process.env.NODE_ENV == 'development' ? true : false,
    modules: [
      {
        name: 'vimeo',
        files: ['//player.vimeo.com/api/player.js']
      },
      {
        name: 'wistia',
        files: ['//fast.wistia.com/assets/external/E-v1.js']
      },
      {
        name: 'hubspotForm',
        files: ['https://js.hsforms.net/forms/v2.js']
      },
      {
        name: 'beacon',
        files: ['https://media.mirasee.com/js/chat/beacon.js']
      },
      {
        name: 'uccart',
        files: [
          'https://secure.ultracart.com/js/jquery-1.11.3.min.js',
          'https://secure.ultracart.com/js/json3.min.js',
          'https://secure.ultracart.com/checkout/checkout-hosted-fields-1.0.js'
        ]
      },
    ]
  });
  $sceDelegateProvider.resourceUrlWhitelist([
    // Allow same origin resource loads.
    'self',
    // Allow loading from our assets domain. **.
    'http://localhost:8081/**',
    'https://mirasee/2022/**',
    'https://mirasee/2023/**'
  ]);
  // $httpProvider.defaults.headers.common.Authorization = 'Bearer ' + token;
}
